import { Component, Input } from '@angular/core';
import { Observable, map, startWith } from 'rxjs';
import { BaseSalesOrdersTableService } from '../interface';
import { TranslateService } from '@ngx-translate/core';
import { Status } from '@vendasta/sales-orders';

@Component({
  selector: 'sales-ui-sales-order-table-stats',
  templateUrl: './sales-order-table-stats.component.html',
  styleUrl: './sales-order-table-stats.component.scss',
  standalone: false,
})
export class SalesOrderTableStatsComponent {
  @Input() set dataService(dataService: BaseSalesOrdersTableService) {
    this.stats$ = dataService?.stats$.pipe(
      map((stats) => this.startCardData(stats)),
      startWith(this.startCardData(null)),
    );
  }
  stats$: Observable<{ title: string; value?: number; loading?: boolean }[]>;

  constructor(private readonly i18n: TranslateService) {}

  startCardData(stats: { [key: string]: number }): { title: string; value?: number; loading?: boolean }[] {
    return [
      {
        title: this.i18n.instant('FRONTEND.SALES_UI.TOTAL_ORDERS'),
        loading: !stats,
        value: this.statValue(stats, Object.values(Status)),
      },
      {
        title: this.i18n.instant('FRONTEND.SALES_UI.PENDING_APPROVAL'),
        loading: !stats,
        value: this.statValue(stats, [Status.SUBMITTED, Status.SUBMITTED_FOR_CUSTOMER_APPROVAL, Status.RESUBMITTED]),
      },
      {
        title: this.i18n.instant('FRONTEND.SALES_UI.CANCELLED'),
        loading: !stats,
        value: this.statValue(stats, [Status.CANCELLED]),
      },
      {
        title: this.i18n.instant('FRONTEND.SALES_UI.APPROVED'),
        loading: !stats,
        value: this.statValue(stats, [Status.APPROVED, Status.SCHEDULED_ACTIVATION, Status.FULFILLED]),
      },
    ];
  }

  statValue(stats: { [key: string]: number }, statuses: (Status | string)[]): number {
    if (!stats) return 0;
    return statuses.reduce((acc, status) => acc + (stats[status] || 0), 0);
  }
}
